import { Stage } from 'src/components/common/util/StageHelpers';

// Build-time-injected Cognito config (webpack DefinePlugin, see configuration/configUtils.js).
// Populated from env vars at build time for personal/per-deploy stacks; empty strings otherwise.
declare const LANGHUB_USER_POOL_ID: string;
declare const LANGHUB_UI_CLIENT_ID: string;
declare const LANGHUB_COGNITO_DOMAIN: string;

export interface AuthConfig {
  AppWebDomain: string;
  ClientId: string;
  RedirectUriSignIn: string;
  RedirectUriSignOut: string;
  TokenScopesArray: Array<string>;
  UserPoolId: string;
}

const tokenScopesArray = ['phone', 'email', 'profile', 'openid'];

export function getAuthConfigByStage(stage: Stage): AuthConfig {
  const callbackUrl = window.location.origin + '/';

  // Personal/per-deploy stacks bake their own Cognito identifiers in at build time so the SPA
  // authenticates against that stack's user pool (whose tokens its AppSync authorizer accepts)
  // rather than a hardcoded shared-stage pool. The redirect URIs still come from the live origin
  // (e.g. the *.cloudfront.net domain), which must be registered as an OAuth callback on the
  // app client. When the injected values are absent (pipeline builds), fall back to the
  // hardcoded per-stage config below.
  if (LANGHUB_USER_POOL_ID && LANGHUB_UI_CLIENT_ID && LANGHUB_COGNITO_DOMAIN) {
    return {
      AppWebDomain: LANGHUB_COGNITO_DOMAIN,
      ClientId: LANGHUB_UI_CLIENT_ID,
      RedirectUriSignIn: callbackUrl,
      RedirectUriSignOut: callbackUrl,
      TokenScopesArray: tokenScopesArray,
      UserPoolId: LANGHUB_USER_POOL_ID,
    };
  }

  if (stage === Stage.Test) {
    stage = Stage.Beta;
  }
  const config: AuthConfig = {
    AppWebDomain: 'langhub-' + stage + '.auth.us-west-2.amazoncognito.com',
    RedirectUriSignIn: callbackUrl,
    RedirectUriSignOut: callbackUrl,
    TokenScopesArray: tokenScopesArray,
    UserPoolId: '',
    ClientId: '',
  };

  switch (stage) {
    case Stage.Gamma:
      config.UserPoolId = 'us-west-2_yEcuiED3Y';
      config.ClientId = '3ngg1rukohckpbbo3efcs9p27l';
      break;

    case Stage.Prod:
      config.UserPoolId = 'us-west-2_FB8U2uZFS';
      config.ClientId = '3k3jeqtat2do1aopuc3s7bto8n';
      break;

    default:
      config.UserPoolId = 'us-west-2_DZ1RpToC1';
      config.ClientId = '2a6ehulus8m74uacor26mn6k7t';
      break;
  }
  return config;
}
